import { NEW_ID } from '@/util/constants';
import { TranslationState } from './translation.model';

export enum MediaPurpose {
  Main = 'main',
  Logo = 'logo',
  ContentImage = 'content-image',
  BackgroundImage = 'background-image',
  DiscountImage = 'discount-image',
  StoryBackgroundImage = 'story-background-image',
  InfoGraphic = 'info-graphic',
}

export interface Media {
  id: number;
  file: FileData | null;
  description: string;
  language?: string;
  purpose: MediaPurpose;
  translated?: TranslationState;
}

export const defaultMedia: Media = {
  id: NEW_ID,
  description: '',
  language: 'all',
  purpose: MediaPurpose.ContentImage,
  file: null,
};

export type FileData = File & { uuid: string; language: string };

export const descriptionRules = [
  (value: string) => {
    if (value) return true;

    return 'description is required.';
  },
];

export const purposeRules = [
  (value: string) => {
    if (value) return true;

    return 'purpose is required.';
  },
];

('watch?v=');
('shorts/');

export const videoRules = [
  (value: string) => {
    if (
      (value.indexOf('youtube') !== -1 &&
        (value.indexOf('watch?v=') !== -1 ||
          value.indexOf('shorts/') !== -1)) ||
      value.indexOf('vimeo') !== -1
    ) {
      return true;
    }

    return 'Only youtube and vimeo urls will work correctly. Please contact the developer if you have other urls';
  },
];

export const purposeItems = [
  { title: 'Main Image', value: MediaPurpose.Main },
  { title: 'Logo Image', value: MediaPurpose.Logo },
  { title: 'Content Image', value: MediaPurpose.ContentImage },
  { title: 'Background Image', value: MediaPurpose.BackgroundImage },
  { title: 'Discount Image', value: MediaPurpose.DiscountImage },
  { title: 'Story Background Image', value: MediaPurpose.StoryBackgroundImage },
  { title: 'Infographic', value: MediaPurpose.InfoGraphic },
];
